import { ImageProps } from 'next/image';

export const storyBlokLoader = ({ src, width, height }: ImageProps): string => {
  if (src.toString().includes('.webp')) {
    return `${src}`;
  }

  return `${src}/m/${width || 0}x${height || 0}`;
};
